
function unifyEvent(e) { return e.changedTouches ? e.changedTouches[0] : e };

const SCROLL_LIMIT = 300;
const FPS = 60;
function easeOutQuad(x, t, b, c, d) {
  return -c * ((t=t/d-1)*t*t*t - 1) + b;
}

export default class AdvancedScrollListener {

  constructor(numberOfSlides, callback, initial = 0) {
    this.callback = callback;
    this.numberOfSlides = numberOfSlides;
    this.scrollTotal = initial;
    this.scrollTo = 0;
    this.startY = 0;
    this.delay = null;
    this.timer = null;
    this.mouseLock = false;
    this.timerScroll = null;
    this.destroyed = false;
  }

  setNumberOfSlides(numberOfSlides) {
    this.numberOfSlides = numberOfSlides;
    if (this.numberOfSlides > 1 ) {
      this.setScroll(0);
    }
  }

  resetScroll() {
    this.scrollTotal = 0;
    this.setScroll(0);
  }

  async goToSlide(position) {
    const percentage = this.scrollTotal / SCROLL_LIMIT;
    const current = Math.floor(percentage);
    if (current === position) {
      return;
    }
    let prev = position;
    prev = prev <= 0 ? this.numberOfSlides - 1 : prev - 1;
    this.scrollTotal = SCROLL_LIMIT * prev;
    return await this.animateToSlide(1, 0.5);
  }

  async goToNextSlide() {
    return await this.animateToSlide(1, 0.5);
  }

  fireCallback() {
    this.callback(this.scrollTotal / SCROLL_LIMIT);
  }

  returnToDefault() {
    const percentage = this.scrollTotal / SCROLL_LIMIT;
    let prev = Math.floor(percentage);
    prev = prev >= this.numberOfSlides - 1 ? this.numberOfSlides - 1 : prev;
    const p = percentage - prev;
    let finish = p > 0.6 ? 1 : 0;
    this.animateToSlide(finish, 0.4);
  }

  animateToSlide(finish, duration) {
    let time = 0;
    cancelAnimationFrame(this.timer);
    const percentage = this.scrollTotal / SCROLL_LIMIT;
    let prev = Math.floor(percentage);
    prev = prev >= this.numberOfSlides - 1 ? this.numberOfSlides - 1 : prev;
    const p = percentage - prev;
    let start = p;
    let startValue = prev * SCROLL_LIMIT;
    return new Promise((resolve) => {
      this.timer = requestAnimationFrame(this.animation('timer', startValue, start, finish, time + (1 / FPS), duration, resolve));
    });
  }

  animation(timerName, startValue, start, finishVal, time, duration, resolve, factor = SCROLL_LIMIT) {
    const finish = typeof finishVal === 'function' ? finishVal() : finishVal;
    return () => {
      if (this.destroyed) {
        return;
      }
      let position = easeOutQuad(time * 100 / duration, time, start, finish - start, duration);

      this.scrollTotal = startValue + position * factor;
      this.scrollTotal = this.scrollTotal < 0 ? SCROLL_LIMIT * (this.numberOfSlides) + this.scrollTotal : this.scrollTotal;
      this.scrollTotal %= SCROLL_LIMIT * (this.numberOfSlides);
      this.fireCallback();
      if ((start > finish && position <= finish) || (start < finish && position >= finish) || start === finish) {
        resolve && resolve();
      } else {
        this[timerName] = requestAnimationFrame(this.animation(timerName, startValue, start, finishVal, time + (1 / FPS), duration, resolve, factor));
      }
    }
  }

  scroll(event) {
    clearTimeout(this.delay);
    cancelAnimationFrame(this.timer);
    this.scrollTo += !event.deltaMode ? event.deltaY : Math.pow(event.deltaY, 3);
    if (this.timerScroll) {
      return;
    }
    // Testa att räkna ut totala scroll och sätt det i en animation
    this.timerScroll = true;

    let time = 0;
    let duration = 0.4;
    let start = 0;
    let startValue = this.scrollTotal;
    this.requestAnimation = requestAnimationFrame(this.animation('requestAnimation', startValue, start, () => this.scrollTo, time + (1 / FPS), duration, () => {
      this.timerScroll = null;
      this.scrollTo = 0;
      this.delay = setTimeout(() => this.returnToDefault(), 4);
    }, 1));
  }

  mouseDown(event) {
    this.mouseLock = true;
    this.startY = unifyEvent(event).clientY;
  }

  mouseUp(event) {
    this.mouseLock = false;
    this.returnToDefault();
  }

  mouseMove(event) {
    if (this.mouseLock) {
      clearTimeout(this.delay);
      cancelAnimationFrame(this.timer);
      const deltaY = unifyEvent(event).clientY - this.startY;
      this.startY = unifyEvent(event).clientY;
      this.setScroll(-deltaY * 2);
    }
  }

  setSlide(position) {
    this.scrollTotal = position * SCROLL_LIMIT;
    this.scrollTotal %= SCROLL_LIMIT * (this.numberOfSlides);
    this.fireCallback();
  }

  setScroll(delta) {
    this.scrollTotal += delta;
    this.scrollTotal = this.scrollTotal < 0 ? SCROLL_LIMIT * (this.numberOfSlides) + this.scrollTotal : this.scrollTotal;
    this.scrollTotal %= SCROLL_LIMIT * (this.numberOfSlides);
    this.fireCallback();
  }

  destroy() {
    this.destroyed = true;
    clearTimeout(this.delay);
    cancelAnimationFrame(this.timer);
    cancelAnimationFrame(this.requestAnimation);
    clearInterval(this.timerScroll);
  }

}
